(() => {
  const MOBILE_QUERY = '(max-width: 767px)';

  const updateBodySpacing = () => {
    document.body.classList.toggle(
      'agawa-sticky-atc-visible',
      Boolean(document.querySelector('.agawa-sticky-atc.is-visible')),
    );
  };

  const initializeStickyBar = (bar) => {
    if (bar.dataset.agawaStickyBound === 'true') return;

    const productForm = bar.closest('product-form');
    const sourceButton = productForm && productForm.querySelector('.product-form__add-btn');
    const stickyButton = bar.querySelector('.agawa-sticky-atc__button');
    if (!sourceButton || !stickyButton) return;

    bar.dataset.agawaStickyBound = 'true';
    document.body.appendChild(bar);

    const update = () => {
      const sourceRect = sourceButton.getBoundingClientRect();
      const sourceIsRendered = sourceButton.getClientRects().length > 0;
      const shouldShow =
        window.matchMedia(MOBILE_QUERY).matches &&
        sourceIsRendered &&
        sourceRect.bottom < 0 &&
        !sourceButton.disabled;

      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      stickyButton.disabled = sourceButton.disabled;
      updateBodySpacing();
    };

    stickyButton.addEventListener('click', () => {
      if (!sourceButton.disabled) sourceButton.click();
    });

    new MutationObserver(update).observe(sourceButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-agawa-sticky-atc]').forEach(initializeStickyBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
